'use client'

import useIsMobile from '@/hooks/useIsMobile'
import CustomCarousel from '../CustomCarousel'
import React, { useMemo, useRef } from 'react'
import Faculty from './Faculty'
import { FacultyProps, FacultySectionProps } from '@/widgets/landing-page-widgets/FacultySection/schema'
import styles from './facultySection.module.css'
import { Typography } from '@pw-tech/omni-ui'

const FacultySection = ({ facultySectionData }: { facultySectionData: FacultySectionProps }) => {
  const { isMobile } = useIsMobile()
  const sliderRef = useRef(null)
  const faculties = facultySectionData?.faculties

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return faculties?.length <= 2 ? faculties?.length : 1.2
    }
    return 4
  }, [isMobile, faculties?.length])

  const arrows = isMobile ? !((faculties?.length || 0) <= 2) : !((faculties?.length || 0) <= 4)

  return (
    <div
      className="px-4 md:py-14 py-6"
      style={{
        background:
          'radial-gradient(60.52% 68.24% at 50% 68.24%, rgba(255, 157, 91, 0.3) 0%, rgba(255, 249, 244, 0.3) 44.14%, rgba(255, 234, 219, 0.3) 100%)',
      }}
    >
      <div className="max-w-6xl mx-auto relative px-4 md:px-6">
        <Typography variant='heading2' weight='bold' className="mb-2 text-center" color='#1b2124'>
          {facultySectionData.heading}
        </Typography>
        <Typography variant='heading4' className="text-center" color='#1b2124'>
          {facultySectionData.subHeading}
        </Typography>

        <div className="mt-6 md:mt-8">
          <CustomCarousel
            items={faculties}
            renderCarouselItem={(
              item: FacultyProps,
              meta: { index: number; activeIndex: number; slidesToShow: number },
            ) => {
              const end = meta.activeIndex + Math.ceil(meta.slidesToShow || 1)
              const isVisible = meta.index >= meta.activeIndex && meta.index < end
              return <Faculty key={item?.name} faculty={item} isVisible={isVisible} />
            }}
            ref={sliderRef}
            slidesToShow={slidesToShow}
            arrows={arrows}
          />
        </div>
      </div>
    </div>
  )
}

export default FacultySection
